<template>
  <v-app class="background">
    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import RegisterStoreModule from '@/mixins/RegisterStoreModule';
import globalStore from './store.js';
import employeeState from '@/modules/Employee/store';

export default {
  name: 'App',
  mixins: [RegisterStoreModule],
  created() {
    this.registerStoreModule('global', globalStore);
    this.registerStoreModule('employee', employeeState)
  },
};

</script>

<style lang="scss">
@import '@/scss/variable.scss';
@import '@/scss/app.scss';
</style>
